export const MODIFY_IMPORT_SHEETS_FILE_INFORMATION = 'MODIFY_IMPORT_SHEETS_FILE_INFORMATION';

export function modifyImportSheetsFileInformation(importSheetsFileInformation){
    return{
        type: MODIFY_IMPORT_SHEETS_FILE_INFORMATION,
        mainState: {
            importSheetsFileInformation: importSheetsFileInformation
        }
    }
}